import { AbstractControl, ValidatorFn } from '@angular/forms';

export function minDurationValidator(minDurationInMinutes: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value == null) return null;
    const valueAsDate = control.value as Date;
    const valueMinutes = valueAsDate.getHours() * 60 + valueAsDate.getMinutes();
    return valueMinutes >= minDurationInMinutes ? null : { minDuration: true };
  };
}

export function isValidEmail(email: string): boolean {
  return !(
    !email.includes('@') ||
    email.includes('"') ||
    email.includes(' ') ||
    /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$/i.exec(email) === null
  );
}
